<template>
    <div style="text-align: left">
        <div class="list">菜单管理</div>
        <div class="content">
            <div class="goods">
                <div class="search">
                    菜单名称：<el-input style="width:200px" v-model="search.menuName"></el-input>
                    <el-button type="primary" style="margin-left:10px" @click="getSearch">搜 索</el-button>
                    <el-button @click="resetSearch">重 置</el-button>
                </div>
                <br>
                <hr>
                <div style="margin-top: 20px">
                    <el-button type="primary" plain @click="dialogVisible = true">新增菜单</el-button>
                    <!-- <el-button type="primary" plain>批量删除</el-button> -->
                </div>
                <br>
            </div>
            <br>
            <div class="menu-list">
                <el-table :data="tableData" style="width: 100%" row-key="id" :tree-props="{ children: 'child' }">
                    <el-table-column prop="menuName" label="菜单" width="180">
                    </el-table-column>
                    <el-table-column prop="orderNum" label="显示顺序" width="180">
                    </el-table-column>
                    <el-table-column label="类型" width="180">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.menuType === 0" effect="dark">目录</el-tag>
                            <el-tag v-if="scope.row.menuType === 1" type="warning" effect="dark">菜单</el-tag>
                            <el-tag v-if="scope.row.menuType === 2" type="info" effect="dark">按钮</el-tag>
                            <el-tag v-if="scope.row.menuType === 3" type="info" effect="dark">页面</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" width="180">
                        <template slot-scope="scope">
                            <el-tag type="success" v-if="scope.row.visible === 0" effect="dark">显示</el-tag>
                            <el-tag type="danger" v-if="scope.row.visible === 1" effect="dark">隐藏</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="api" label="接口" width="200">
                    </el-table-column>
                    <el-table-column prop="url" label="路由" width="180">
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="openModify(scope.row)">修改</el-button>
                            <el-button type="text" size="small" @click="deleteMenu(scope.row)">移除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>



        <!-- 新增菜单弹窗 -->
        <el-dialog :title="(directoryForm.id === '' ? '添加' : '编辑')" :visible.sync="dialogVisible" width="35%"
            :before-close="handleClose">
            <el-form :model="directoryForm" :rules="rules" ref="directoryForm" label-width="100px"
                class="demo-ruleForm">
                <el-form-item label="菜单类型" prop="menuType">
                    <el-select v-model="directoryForm.menuType" placeholder="请选类型" clearable @change="resetParentId">
                        <el-option label="目录" :value="0"></el-option>
                        <el-option label="菜单" :value="1"></el-option>
                        <el-option label="按钮" :value="2"></el-option>
                        <el-option label="单独页面" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="directoryForm.menuType === 0" label="目录名称" prop="menuName">
                    <el-input v-model="directoryForm.menuName"></el-input>
                </el-form-item>
                <el-form-item v-if="directoryForm.menuType === 1" label="父级目录" prop="parentId">
                    <el-select v-model="directoryForm.parentId" placeholder="请选择父级目录" @visible-change="getTree"
                        clearable>
                        <el-option v-for="item in options" :key="item.menuId" :label="item.menuName"
                            :value="item.menuId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="父级菜单" prop="parentId"
                    v-if="directoryForm.menuType === 2 || directoryForm.menuType === 3">
                    <el-select v-model="directoryForm.parentId" placeholder="请选择父级菜单" @visible-change="getTree1"
                        clearable>
                        <el-option v-for="item in options" :key="item.menuId" :label="item.menuName"
                            :value="item.menuId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="directoryForm.menuType === 3" label="页面名称" prop="menuName">
                    <el-input v-model="directoryForm.menuName"></el-input>
                </el-form-item>
                <el-form-item label="菜单名称" prop="menuName" v-if="directoryForm.menuType === 1">
                    <el-input v-model="directoryForm.menuName"></el-input>
                </el-form-item>
                <el-form-item label="按钮名称" prop="menuName" v-if="directoryForm.menuType === 2">
                    <el-input v-model="directoryForm.menuName"></el-input>
                </el-form-item>
                <el-form-item v-if="directoryForm.menuType === 0 || directoryForm.menuType === 1" label="菜单图标"
                    prop="icon">
                    <el-input v-model="directoryForm.icon" placeholder="例：el-icon-arrow-down"></el-input>
                </el-form-item>
                <span v-if="directoryForm.menuType === 1 || directoryForm.menuType === 0"
                    style="font-size:10px;color:#a0a0a0;margin-left: 15%;">
                    图标参考网址：https://element.eleme.cn/#/zh-CN/component/icon
                </span>
                <el-form-item label="请求地址" prop="api" v-if="directoryForm.menuType !== 3">
                    <el-input v-model="directoryForm.api" placeholder="例：/admin/menu/add"></el-input>
                </el-form-item>
                <el-form-item label="路由地址" prop="url"
                    v-if="directoryForm.menuType === 1 || directoryForm.menuType === 3">
                    <el-input v-model="directoryForm.url" placeholder="例：/menuManage"></el-input>
                </el-form-item>
                <el-form-item label="显示顺序" prop="orderNum" v-if="directoryForm.menuType !== 3">
                    <el-input v-model="directoryForm.orderNum"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="resetForm('directoryForm')">取 消</el-button>
                <el-button v-if="directoryForm.id === ''" type="primary" @click="submitForm('directoryForm')">确
                    定</el-button>
                <el-button v-else type="primary" @click="submitForm('directoryForm')">编 辑</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import request from '../utils/request';
export default {
    data() {
        return {
            // 新增菜单弹窗
            dialogVisible: false,
            // 默认菜单
            activeName: 'first',
            // 新增目录表单
            directoryForm: {
                id: '',
                menuName: '',
                icon: '',
                menuId: '',
                menuType: '',
                parentId: '',
                api: '',
                url: '',
                visible: '0',
                orderNum: ''
            },
            // 父级目录
            options: [],
            // 新增校验
            rules: {
                menuName: [
                    { required: true, message: '请输入活动名称', trigger: 'blur' },
                ],
                menuType: [
                    { required: true, message: '请选择菜单类型', trigger: 'blur' },
                ],
                // icon: [
                //     { required: true, message: '请输入icon图标', trigger: 'blur' },
                // ],
                api: [
                    { required: true, message: '请输入请求地址', trigger: 'blur' },
                ],
                url: [
                    { required: true, message: '请输入路由地址', trigger: 'blur' },
                ],
                parentId: [
                    { required: true, message: '请选择父级目录', trigger: 'blur' },
                ],
            },
            // 表格数据
            tableData: [],
            // 模糊查询数据
            search: {
                isPage: false,
                menuName: '',
            }
        }
    },
    methods: {
        // 是否关闭弹窗
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(() => {
                    this.resetForm('directoryForm')
                    this.activeName = 'first'
                    done();
                })
                .catch(() => { });
        },
        //添加不同菜单切换
        // handleClick(tab, event) {
        handleClick(tab) {
            //console.log(tab, event);
            //console.log(tab.label);
            if (tab.label === '添加目录') {
                this.$refs['directoryForm'].resetFields();
                this.resetAddForm()
            } else if (tab.label === '添加菜单') {
                this.$refs['directoryForm'].resetFields();
                this.resetAddForm()
                this.directoryForm.menuType = '1'
                this.directoryForm.parentId = ''
            } else if (tab.label === '添加按钮') {
                this.$refs['directoryForm'].resetFields();
                this.resetAddForm()
                this.directoryForm.menuType = '2'
                this.directoryForm.parentId = ''
            }
        },
        // 表单校验
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.directoryForm.id === '') {
                        this.addDirectory()
                    } else {
                        this.modifyDirectory()
                    }
                    this.resetForm('directoryForm')
                } else {
                    return false;
                }
            });
        },
        // 校验重置
        resetForm(formName) {
            this.dialogVisible = false
            this.$refs[formName].resetFields();
            this.resetAddForm()
            this.activeName = 'first'
        },
        // 新增表单重置
        resetAddForm() {
            this.directoryForm.menuName = ''
            this.directoryForm.menuId = ''
            this.directoryForm.icon = ''
            this.directoryForm.menuType = ''
            this.directoryForm.parentId = ''
            this.directoryForm.api = ''
            this.directoryForm.url = ''
            this.directoryForm.orderNum = ''
            this.directoryForm.id = ''
        },
        // 新增
        async addDirectory() {
            const res = await request({
                url: 'admin/menu/add',
                method: 'POST',
                data: this.directoryForm
            })
            //console.log(res);
            if (res.code === '200') {
                this.$message.success(res.message)
                this.getTree2()
            } else {
                this.$message.error(res.message)
            }
            this.activeName = 'first'
        },
        // 查询目录结构树
        async getTree() {
            let obj = {
                menuName: '无目录',
                menuId: '0'
            }
            const res = await request({
                url: 'admin/menu/tree',
                method: 'POST',
            })
            if (res.code === '200') {
                //console.log(res);
                this.options = res.data
            } else {
                return
            }
            this.options.unshift(obj)
        },
        // 查询目录结构树
        async getTree2() {
            const res = await request({
                url: 'admin/menu/tree',
                method: 'POST',
            })
            if (res.code === '200') {
                //console.log(res);
                this.tableData = res.data
            } else {
                return
            }
        },
        // 查询菜单结构树
        async getTree1() {
            const res = await request({
                url: 'admin/menu/tree',
                method: 'POST',
            })
            //console.log(res);
            if (res.code === '200') {
                // //console.log(res);
                let arr = []
                res.data.forEach(v => {
                    // //console.log(v.menuType);
                    // //console.log(v.child);
                    if (v.menuType === 1) {
                        arr.push(v)
                        v.child.forEach(h => {
                            if (h.menuType === 3) {
                                arr.push(h)
                            }
                        })
                    } else if (v.menuType === 2) {
                        //console.log(v.menuType === 2);
                        //console.log(v.menuName === '首页');
                        if (v.menuName === '首页') {
                            arr.unshift(v)
                        }
                    } else {
                        v.child.forEach(h => {
                            arr.push(h)
                        })
                    }

                });
                arr.unshift({ menuId: '0', menuName: '无' })
                this.options = arr
            } else {
                return
            }
        },
        // 修改弹窗
        openModify(val) {
            //console.log(val);
            if (val.menuType === 1) {
                this.getTree()
            } else if (val.menuType === 2) {
                this.getTree1()
            }
            this.dialogVisible = true
            this.directoryForm.menuName = val.menuName
            this.directoryForm.menuId = val.menuId
            this.directoryForm.icon = val.icon
            this.directoryForm.menuType = val.menuType
            this.directoryForm.parentId = val.parentId
            this.directoryForm.api = val.api
            this.directoryForm.url = val.url
            this.directoryForm.orderNum = val.orderNum
            this.directoryForm.id = val.id
        },
        // 删除菜单
        deleteMenu(val) {
            this.$confirm('确认移除？')
                .then(async () => {
                    const res = await request({
                        url: `admin/menu/delete/menu?menuId=${val.id}`,
                        method: 'GET'
                    })
                    if (res.code === '200') {
                        this.$message.success(res.message)
                        this.getTree2()
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(() => { });

        },
        // 修改目录
        async modifyDirectory() {
            const res = await request({
                url: 'admin/menu/update',
                method: 'POST',
                data: this.directoryForm
            })
            //console.log(res);
            if (res.code === '200') {
                this.$message.success(res.message)
                this.getTree2()
            } else {
                this.$message.error(res.message)
            }
        },
        // 重置ParentId
        resetParentId() {
            if (this.directoryForm.menuType === 0) {
                this.directoryForm.parentId = 0
            } else {
                this.directoryForm.parentId = ''
            }

        },
        // 模糊查询
        async getSearch() {
            const res = await request({
                url: 'admin/menu/list',
                method: 'POST',
                data: this.search
            })
            //console.log(res);
            if (res.code === '200') {
                this.tableData = res.data && res.data.list
                this.$message.success(res.message)
            } else {
                this.$message.error(res.message)
            }
        },
        // 重置查询
        resetSearch() {
            this.search.menuName = ''
            this.getTree2(0)
        }
    },
    created() {
        this.getTree2()
    }
}
</script>

<style lang="scss" scoped>
.list {
    background-color: #2589ff;
    color: #fff;
    text-align: center;
    width: 106px;
    height: 36px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    border-radius: 6px;
}

.content {
    margin: 20px 0 0 0;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 5px;
}

.goods {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px;
    // display: flex;
    justify-content: space-between;


    .input-with-select {
        padding: 0;
    }
}

.search {
    line-height: 40px;
}
.menu-list{
    min-height: 600px;
    background-color: #fff;
}
</style>